import { SxProps, useTheme } from '@mui/material';

import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';
import { useMytaverse } from '../../providers/MytaverseProvider';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  const { appTheme } = useMytaverse();

  return {
    root: {
      '& .MuiBackdrop-root': {
        backgroundColor: '#00000066',
        backdropFilter: ' blur(12px)',
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      justifyContent: 'center',
      padding: '64px 72px',
      height: 'auto',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 824,
      background: colors.white,
      borderRadius: '30px',
      maxHeight: 'calc(100vh - 32px)',
      maxWidth: 'calc(100vw - 32px)',
      overflow: 'auto',
      [breakpoints.down(ScreenSizes.PcLarge)]: {
        padding: '32px 40px',
        width: 530,
      },
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: 360,
        textAlign: 'center',
      },

      '&:focus-visible': {
        outline: 'none',
      },
    } as SxProps,
    closeIcon: {
      position: 'absolute',
      top: 13,
      right: 13,
      color: '#939393',
      fontSize: 14,
      cursor: 'pointer',
    },
    iconContainer: {
      display: 'flex',
      background: appTheme?.mainColor,
      borderRadius: 9,
      padding: 1,
      '& svg': {
        color: colors.white,
        width: 32,
        height: 32,
      },
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        padding: 0.75,
        '& svg': {
          width: 20,
          height: 20,
        },
      },
    },
    title: {
      fontFamily: 'Primary-Bold',
      fontSize: 40,
      lineHeight: 1,
      color: colors.black,
      letterSpacing: '0.01em',
      marginTop: '28px',
      [breakpoints.down(ScreenSizes.PcLarge)]: {
        fontSize: 32,
        marginTop: 2.5,
      },
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 24,
        marginTop: 2.5,
      },
    },
    description: {
      fontWeight: 400,
      fontSize: 24,
      lineHeight: 1.4,
      color: colors.black,
      marginTop: 2.5,
      letterSpacing: '0.01em',
      [breakpoints.down(ScreenSizes.PcLarge)]: {
        fontSize: 16,
        marginTop: 2,
      },
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'center',
      columnGap: 3,
      marginTop: '22px',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: '100%',
        justifyContent: 'space-between',
        marginTop: 2.5,
      },
    },
    button: {
      px: 8,
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 18,
        px: 2.5,
        py: 1.25,
      },
    },
    close: {
      position: 'absolute',
      top: 40,
      right: 40,
      fontSize: 21,
      color: colors.black,
      cursor: 'pointer',

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        top: 20,
        right: 20,
        fontSize: 15,
      },
    },
  };
};
